import { BookingStatus } from '../api/types/response/booking.response';
import { BookingState } from '../types/booking-state';

export const getBookingStatus = (
  from: number,
  to: number,
  status: BookingStatus,
): BookingState => {
  const fromDate = new Date(from);
  const toDate = new Date(to);
  const currentDate = new Date();
  const isCurrentDateBetweenFromAndTo =
    currentDate >= fromDate && currentDate <= toDate;

  if (isCurrentDateBetweenFromAndTo && status === 'BOOKED') {
    return 'STARTED';
  }

  return status;
};
